import { Checkbox, Dropdown, Button, Menu } from 'antd';
import { useSnapshot } from 'valtio';
import { useEffect } from 'react';

import { state } from '../../../store/state';
import type { CustomSettingsWidgetProps } from '..';
import { gtmTypeIcons } from './gtmTypeIcons';
import type { GtmType } from '../../../store/constants';

interface GtmTypeState {
    default: number;
    gtm_id: number;
    visible: boolean;
}

export const GtmTypeSettings = ({ defaultValue, onChange }: CustomSettingsWidgetProps) => {
    const $state = useSnapshot(state);

    // при смене месторождения меняется общий набор ГТМ
    useEffect(() => {
        onChange(summary(state.gtmTypes, defaultValue));
    }, [$state.gtmTypes]);

    // суммируем данные из полного массива настроек гтм и полученных настроек
    const summary = (fullArr: GtmType[], incomingArr: unknown): GtmTypeState[] => {
        return fullArr.map(({ id, defaultIconId }) => {
            let setIconId = defaultIconId;
            let setVisible = true;
            if (Array.isArray(incomingArr)) {
                // @ts-ignore
                const matchedGtm = incomingArr.find(({ gtm_id }) => gtm_id === id);
                if (matchedGtm !== undefined) {
                    setIconId = matchedGtm.default;
                    setVisible = matchedGtm.visible;
                }
            }
            return {
                gtm_id: id,
                default: setIconId,
                visible: setVisible,
            };
        });
    };

    const applyVisible = (gtmId: number, newVal: boolean): void => {
        const toApply = summary(state.gtmTypes, defaultValue);
        const changeIndex = toApply.findIndex(val => val.gtm_id === gtmId);
        if (changeIndex >= 0) {
            toApply[changeIndex].visible = newVal;
            onChange(toApply);
        }
    };

    const applyIcon = (gtmId: number, newVal: number): void => {
        const toApply = summary(state.gtmTypes, defaultValue);
        const changeIndex = toApply.findIndex(val => val.gtm_id === gtmId);
        if (changeIndex >= 0) {
            toApply[changeIndex].default = newVal;
            onChange(toApply);
        }
    };

    const iconsDropdownMenu = (gtmId: number) => (
        <Menu>
            {Array.from(gtmTypeIcons.entries())
                .filter(([key]) => key >= 0)
                .map(([key, Icon]) => (
                    <Menu.Item
                        key={key}
                        onClick={() => {
                            applyIcon(gtmId, key);
                        }}
                    >
                        <Icon className="h-6 w-6" />
                    </Menu.Item>
                ))}
        </Menu>
    );

    return (
        <div className="flex w-full flex-col p-3">
            <div className="fles w-full items-center py-1 text-xs text-black dark:text-font-secondary">Типы ГТМ:</div>
            {/* @ts-ignore */}
            {summary($state.gtmTypes, defaultValue).map(({ gtm_id, visible, default: icon_id }) => {
                const forTitle = state.gtmTypes.find(({ id }) => id === gtm_id);
                const title = forTitle !== undefined ? forTitle.title : '';
                const FinalIcon = gtmTypeIcons.get(icon_id);

                return (
                    <div key={gtm_id} className="flex w-full items-center justify-between p-1">
                        <div className="flex w-8 items-center">
                            <Checkbox
                                defaultChecked={visible}
                                onChange={event => applyVisible(gtm_id, event.target.checked)}
                            />
                        </div>
                        <div className="flex w-full items-center pr-2 text-xs text-black dark:text-font-secondary">
                            {title}
                        </div>
                        <div className="flex w-6 items-center">
                            <Dropdown popupRender={() => iconsDropdownMenu(gtm_id)} placement="topCenter">
                                <Button className="!h-7 !min-w-7 !w-7 !rounded !border-none !p-1">
                                    {FinalIcon !== undefined && <FinalIcon className="h-6 w-6" />}
                                </Button>
                            </Dropdown>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
